import { faTrashCan, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";

import ConfigurationTab from "./ConfigurationTab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageCard from "./MessageCard";
import { useMessages } from "../../hooks/useMessages";

function CardModal({ token, card, onClose, onTrashCanIconPress }) {
  const scrollableRef = useRef(null);
  const { messages, loading, error } = useMessages(card.topics[0].id);
  const [activeTab, setActiveTab] = useState("messages"); // Manage active tab

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "messages":
        return (
          <>
            {loading ? (
              <div>Loading messages...</div>
            ) : error ? (
              <div className="text-red-500">{error}</div>
            ) : messages.length > 0 ? (
              messages.map((message) => (
                <MessageCard key={message.id} message={message} />
              ))
            ) : (
              <div>No messages found.</div>
            )}
          </>
        );
      case "configuration":
        return (
          <ConfigurationTab
            token={token}
            card={card}
            onSave={onClose}
            modalRef={scrollableRef}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div className="bg-white rounded-xl shadow-lg w-11/12 md:w-3/4 lg:w-3/4 p-3 overflow-y-auto">
        {/* Modal Header with Tabs */}
        <div className="pb-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold">
              {card.type.toUpperCase()} -{" "}
              {card.topics.map((topic) => topic.name).join(" | ")}
            </h2>
            <div>
              <button onClick={onTrashCanIconPress}>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="text-gray-500 hover:text-red-500 text-lg align-middle"
                />
              </button>
              &nbsp;&nbsp;
              <button onClick={onClose}>
                <FontAwesomeIcon
                  icon={faXmark}
                  className="text-gray-500 hover:text-black text-2xl align-middle"
                />
              </button>
            </div>
          </div>
          {/* Tab Navigation */}
          <div className="flex border-b">
            <button
              className={`px-4 py-2 ${
                activeTab === "messages"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("messages")}
            >
              Messages
            </button>

            <button
              className={`px-4 py-2 ${
                activeTab === "configuration"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("configuration")}
            >
              Configuration
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div ref={scrollableRef} className="max-h-[65vh] overflow-y-auto">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default CardModal;
